<template >
  <!-- .child-wrap ul li(v-for='item in currentData') .name span(v-if='item.type ==
  1') i.el-icon-folder-add(v-show='!item.fold', @click='handleFold(item, true)')
  i.el-icon-folder-remove(v-show='item.fold', @click='handleFold(item, false)')
  i.el-icon-document(v-if='item.type ==2') span.label( @click='choose(item)',
  :class='{"active": item.id === currentId}' ) {{ item.chapterNo
  }}{{ item.name }}
  tree( :currentId='currentId', :choose='choose', v-show='item.fold',
  v-if='item.subChapters && item.subChapters.length',
  :dataSource='item.subChapters' ) -->

  <div class="child-wrap">
    <ul>
      <li v-for="(item, index) in currentData" :key="index" draggable="true">
        <div class="name">
          <span v-if="item.type == 1">
            <i
              class="el-icon-folder-add"
              v-show="!item.fold"
              @click="handleFold(item, true)"
            ></i>
            <i
              class="el-icon-folder-remove"
              v-show="item.fold"
              @click="handleFold(item, false)"
            ></i>
          </span>
          <i class="el-icon-document" v-if="item.type == 2"></i>
          <span
            class="label"
            @click="choose(item)"
            :class="{ active: item.id === currentId }"
            >{{ item.chapterNo }}{{ item.name }}</span
          >
        </div>
        <tree
          :currentId="currentId"
          :choose="choose"
          v-show="item.fold"
          v-if="item.subChapters && item.subChapters.length"
          :dataSource="item.subChapters"
        ></tree>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  name: "tree",
  data() {
    return {
      currentData: {}
    };
  },
  watch: {
    dataSource: {
      handler(val) {
        this.currentData = _.cloneDeep(val);
        // for(let i = 0; i < this.currentData.length;i++){
        // 	this.$set(this.currentData[i], 'fold', true);
        // }
      },
      deep: true
    }
  },
  mounted() {
    this.dataSource && (this.currentData = _.cloneDeep(this.dataSource));
    // this.$set(this.currentData, 'fold', true);
  },
  props: ["dataSource", "choose", "currentId"],
  methods: {
    handleFold(obj, flag) {
      if (obj.fold === undefined) {
        this.$set(obj, "fold", flag);
      } else {
        obj.fold = flag;
      }
    },
    handleDragStart(node, ev) {
      console.log("drag start", node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log("tree drag end: ", dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
    },

    allowDrag(draggingNode, dropNode, type) {
      console.log(draggingNode, "draggingNode");
      return draggingNode.data.label.indexOf("三级 3-2-2") === -1;
    },

    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.level === dropNode.level) {
        if (draggingNode.parent.id === dropNode.parent.id) {
          // 向上拖拽 || 向下拖拽
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.child-wrap {
  ul {
    border-left: 1px solid #ccc;
    margin-left: 5px;
    li {
      padding-left: 20px;
      line-height: 20px;
      .name {
        margin-bottom: 4px;
        i {
          margin-right: 6px;
        }
        i.el-icon-folder-add,
        i.el-icon-folder-remove {
          cursor: pointer;
        }
      }
      span.label {
        cursor: pointer;
      }
      span.active {
        color: #409eff;
      }
    }
  }
}
</style>